import { updateMemberSubscription } from 'actions/LuxPlusActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import getCanPayLuxPlusRenewalWithPoints from 'luxPlus/selectors/getCanPayLuxPlusRenewalWithPoints'
import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import { reportClientError } from 'services/errorReportingService'
import LuxPlusRenewalPointsCheckbox from './LuxPlusRenewalPointsCheckbox'

/**
 * Lets an existing member opt in or out of paying renewals with Société points.
 * Reads and writes the shared subscription in state, so every place it's shown stays in sync.
 */
function LuxPlusRenewalPointsOptIn() {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const canPayWithPoints = useAppSelector(getCanPayLuxPlusRenewalWithPoints)
  const subscription = useAppSelector(state => state.auth.account.luxPlus.member.subscription.item)
  const memberId = useAppSelector(state => state.auth.account.memberId)
  const [saving, setSaving] = useState(false)

  const handleChange = useCallback(async(checked: boolean) => {
    setSaving(true)
    try {
      await dispatch(updateMemberSubscription({ payRenewalWithPoints: checked }))
    } catch(error) {
      reportClientError(error, { memberId, context: 'lux_plus_renewal_points_update_failed' })
      showSnackbar(intl.formatMessage({
        id: 'YVqy0sIk6OCuL8HB02v5',
        defaultMessage: 'We couldn’t update how your renewal is paid. Please try again.',
        description: 'Error snackbar shown when saving the LuxPlus renewal points preference fails',
      }), 'critical')
    } finally {
      setSaving(false)
    }
  }, [dispatch, intl, memberId])

  // Nothing to pay for if the member has turned off auto-renewal.
  if (!canPayWithPoints || subscription?.renewalStatus !== 'ALLOW_RENEWAL') return null

  return <LuxPlusRenewalPointsCheckbox
    checked={subscription.payRenewalWithPoints}
    disabled={saving}
    onChange={handleChange}
  />
}

export default LuxPlusRenewalPointsOptIn
